import { UserRole } from '@grcs/types/UserRole';
import { ProtectedRoute, ProtectedRouteProps } from './ProtectedRoute';

export const AdminProtectedRoute: React.FC<
  Pick<ProtectedRouteProps, 'children'>
> = ({ children }) => {
  return <ProtectedRoute access={UserRole.ADMIN}>{children}</ProtectedRoute>;
};
